import React from "react";
import SubHeader from "../general/SubHeader";
import Krishna from "../../assets/member/KrishnaPandey.jpeg";

const KrishnaKumar = () => {
  return (
    <>
      <SubHeader message="Members" />

      <section className="my-5">
        <div className="container text-center">
          <div className="sec-subheading">
            <hr />
            <span>Members</span>
            <hr />
          </div>
          <p className="sec-heading">Our Management Group</p>

          <div className="member-area row mt-5">
            <div className="col-lg-4 col-12 my-3 pe-lg-0">
              <img
                src={Krishna}
                className="img-fluid border-0 rounded"
                alt="Agents"
              />
            </div>

            <div className="col-lg-8 col-12 my-3 text-muted">
              <div className="member-info">
                <p className="fw-bold fs-5 my-0 text-dark">
                  Krishna Kumar Pandey
                </p>
                <span>Project Manager</span>
                <br />
                <p className="mt-3 para-text fw-bold">
                  Education: Law Graduate
                  <br />
                  Experience: 10 years as Real Estate Consultant
                </p>

                <p>
                  Krishna Kumar Pandey is an experienced Project Manager at
                  Swalok Group, bringing a unique blend of legal expertise and
                  real estate consulting experience to the role. A law graduate,
                  Krishna possesses a deep understanding of legal principles,
                  which he effectively applies to managing projects, ensuring
                  all legal aspects are addressed and compliant with relevant
                  regulations. His legal background allows him to navigate
                  complex contractual agreements and mitigate risks, adding
                  significant value to the projects he oversees.
                  <br />
                  <br />
                  With 10 years of experience as a Real Estate Consultant,
                  Krishna has honed his skills in property management, market
                  analysis, and investment strategies. He has successfully
                  assisted clients in making informed decisions, enhancing their
                  real estate portfolios, and ensuring that deals are structured
                  to maximize returns. His extensive knowledge of the real
                  estate sector provides a strategic advantage in managing
                  projects that involve property development and investment.
                  <br />
                  <br />
                  <strong>
                    In his role as Project Manager at Swalok Group, Krishna is
                    responsible for coordinating various teams, managing
                    resources, and ensuring projects are completed on time and
                    within budget. His leadership, strategic thinking, and
                    ability to handle complex challenges make him an asset to
                    the organization.
                  </strong>
                </p>
              </div>
            </div>
          </div>
          {/* row ends */}
        </div>
      </section>
    </>
  );
};

export default KrishnaKumar;
